export let TicketProviders;(function(a){a.EditorList="EditorListTicketProvider",a.ImageMarkers="EditorImageMarkers"})(TicketProviders||(TicketProviders={}));